import React from 'react';
import { Check, ShieldCheck, Lock, Zap } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
import { CTAButton } from './shared/CTAButton';
export function ProgramIntro() {
  const features = ['45 clases (100% online)', 'Acceso de por vida + actualizaciones', 'Certificado avalado por la instructora', 'Acceso inmediato por email apenas comprás', 'Garantía 7 días', 'Pago seguro'];
  return <SectionWrapper bg="white" data-id="element-208">
      <div className="max-w-3xl mx-auto text-center" data-id="element-209">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-6" data-id="element-210">
          Por eso existe el Programa Profesional{' '}
          <span className="text-rose block mt-2" data-id="element-211">Nails Artist Expert</span>
        </h2>

        <p className="text-lg text-warm-muted mb-12" data-id="element-212">
          Una formación <strong data-id="element-213">100% online</strong> creada para convertirte en{' '}
          <strong data-id="element-214">Manicurista Profesional</strong> trabajando lo que realmente
          cambia tu nivel: <br data-id="element-215" />
          <span className="text-warm-dark font-medium mt-2 block" data-id="element-216">
            preparación, estructura, torno y terminación.
          </span>
        </p>

        <div className="bg-cream rounded-3xl p-8 md:p-10 shadow-soft border border-blush text-left mb-10" data-id="element-217">
          <h3 className="text-2xl font-serif font-bold text-warm-dark mb-6 text-center" data-id="element-218">
            ¿Qué incluye tu acceso?
          </h3>

          <ul className="space-y-4" data-id="element-219">
            {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-220">
                <div className="bg-success/10 p-1 rounded-full shrink-0 mt-0.5" data-id="element-221">
                  <Check className="w-4 h-4 text-success" strokeWidth={3} data-id="element-222" />
                </div>
                <span className="text-warm-dark font-medium" data-id="element-223">{feature}</span>
              </li>)}
          </ul>
        </div>

        <CTAButton scrollTo="comprar" className="mb-6 text-lg px-10 py-5 w-full md:w-auto" data-id="element-224">
          ACCEDER AHORA POR $29 USD
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-sm text-warm-muted font-medium" data-id="element-225">
          <span className="flex items-center gap-1.5" data-id="element-226">
            <Lock className="w-4 h-4 text-rose" data-id="element-227" /> Pago seguro
          </span>
        </div>
      </div>
    </SectionWrapper>;
}